
import { ActionTypes, ILocal145OpAction, ILocal145OpState } from 'app/redux/Customers/local145/reducer'
import { PensionActionCreator } from 'app/redux/Pensions/actions'
import { ILocal145RunCalculationsRequest, Local145WorkbookDAO, Local145WorkbookDAOCalculator } from 'app/workbookDAOs/local145DAO'
import * as _ from 'lodash'

class Local145ActionCreator extends PensionActionCreator<ILocal145OpState, ILocal145OpAction> {
  public workbook: Local145WorkbookDAO

  constructor() {
    super(ActionTypes)

    // This is a kind of a hack- sharing a single Action between different operations. But since
    // we're really after a busy status change, we'll see if we can live with it
    this.workbook = new Local145WorkbookDAO(this)
  }

}

function memorializer(a: ILocal145RunCalculationsRequest) {
  const g = (({ member, spouse, vals, ioInputs, nebfInputs, shared }) => ({ member, spouse, vals, ioInputs, nebfInputs, shared  }))(a)
  // tslint:disable-next-line:no-console
  //console.log('memo: ' + JSON.stringify(g.nebfInputs))
  return JSON.stringify(g)
}

const Local145Actions = new Local145ActionCreator()
const cachedLocal145RunCalculations = _.memoize((req: ILocal145RunCalculationsRequest) => {
  return Local145Actions.workbook.runCalculations(req)
}, memorializer) as Local145WorkbookDAOCalculator
const cachedLocal145ExportExhibitTab = _.memoize((req: ILocal145RunCalculationsRequest) => {
  return Local145Actions.workbook.exportExhibitTab(req)
}, memorializer) as Local145WorkbookDAOCalculator
export {
  Local145Actions,
  Local145ActionCreator,

  cachedLocal145ExportExhibitTab,
  cachedLocal145RunCalculations
}



// WEBPACK FOOTER //
// ./src/app/redux/Customers/local145/actions/index.ts